// extracted by mini-css-extract-plugin
export default {"action":"Action-module__action--a4dc"};